import glassButton from './glassButton.component';

export default angular
  .module('st.Integrations.Glass', ['st.Core', 'angular-cache'])
  .component('glassButton', glassButton)
  .service('glassService', ($http, dataService, GLASS) => ({
    search: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, GLASS.API.SEARCH, params)
  }))
  .constant('GLASS', {
    API: {
      SEARCH: '/api/v1/integration/glasss/'
    },
    REQUEST_TYPE: {
      LIST_OF_YEARS: 'getListOfYears',
      LIST_OF_MAKES_YEAR_FROM_TO: 'getListOfMakesYearFromTo',
      LIST_OF_MODELS_YEAR_FROM_TO: 'getListOfModelsYearFromTo',
      LIST_OF_SERIES_YEAR_FROM_TO: 'getListOfSeriesYearFromTo',
      LIST_OF_VARIANTS_YEAR_FROM_TO: 'getListOfVariantsYearFromTo',
      LIST_OF_OPTIONS_FOR_NVIC: 'getListOfOptionsForNVIC',
      LIST_OF_NVICFOR_ADVANCED_SEARCH: 'getListOfNVICForAdvancedSearch',
      DETAILS_SPECIFICATION_ALL: 'getDetailsSpecificationAll',
      GET_KM_ADJUSTMENT_BY_NVIC: 'getKMAdjustmentByNVIC',
      GET_KM_ADJUSTMENT_BY_CATEGORY_CODE: 'getKMAdjustmentByCategoryCode',
      GET_OPTIONS_VALUE: 'getOptionsValue'
    },
    MODEL_TYPE_CODE: {
      ALL_VEHICLES: 'A',
      PASSENGER_VEHICLE: 'APAS',
      CARAVANS_CAMPERVANS_MOTORHOMES: 'C',
      LIGHT_COMMERICAL: 'ALCV',
      HEAVY_COMMERICAL: 'AHCV'
    }
  });
